import React, { useEffect, useState } from "react";
import moment from "moment";
import { config } from "../utils/config";
import { doRequest } from "../utils/helper";
import { useParams } from "react-router-dom";

export default function UserBillingItem({ planDetails }) {

    const [userDetails, setUserDetails] = useState({});
    let { id } = useParams();

  const renderStartDate = (item) => {
    if (item?.start_date) {
      return moment(item?.start_date).format("DD-MM-yyyy");
    }

    return moment(item?.created_at).format("DD-MM-yyyy");
  }

    const getUserDetails = async (id) => {
      try {
        let res = await doRequest("", "GET", `user/list?id=${id}`);
        if (res && +res?.resultFlag === 1) {
          let user = res?.response?.user;
          if (user?.length > 0) {
            setUserDetails(res?.response?.user[0]);
          } else {
            setUserDetails({});
          }
        }
      } catch (error) {}
    };
    useEffect(() => {
      if (id && id !== "") {
        getUserDetails(id);
      }
    }, [id]);

    const activePlanId = userDetails?.user_plan_id;
  return (
    <>
      {planDetails &&
        planDetails.length > 0 &&
        planDetails.map((item, index) => {
          return (
            <ul className="plan_billheader plan_billheader_list">
              <li className="planbill_wid">
                <h6 className="plan_goldcol">{item?.name}</h6>
              </li>

              <li className="am_wid">
                <h6 className="amount_plali">
                  <sup>₹</sup>
                  <span>{item?.price}</span>
                </h6>
              </li>

              <li className="var_wid">
                <h6 className="var_wid_h">{item?.variant_count}</h6>
              </li>

              <li className="start_wid">
                <h6 className="var_wid_h">
                  {renderStartDate(item)}
                </h6>
              </li>

              <li className="end_wid">
                <h6 className="var_wid_h">
                  {item?.end_date ? moment(item?.end_date).format("DD-MM-yyyy") : ""}
                </h6>
              </li>

              {/* <li className="stat_wid">
                <h6 style={{ color: "#18763C" }}>Active</h6>
              </li> */}
              <li className="stat_wid">
              {item.id === activePlanId && userDetails?.plan_status.toLowerCase() === "active" ? (
                <h6 style={{ color: "#18763C" }}>Active</h6>
              ) : (
                <h6 style={{ color: "#C0392B" }}>Expired</h6>
              )}
            </li>

              {item?.invoice_no !== "" && (
                <li className="dwnin_wid">
                  <a
                    className="down_inlink"
                    href={`${config.invoiceUrl}/invoice/${item?.invoice_no}.pdf`}
                  >
                    DOWNLOAD
                  </a>
                </li>
              )}
            </ul>
          );
        })}
    </>
  );
}
